import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../assets/Animations'
import useFetch from '../../hooks/useFetch'
import './invoice-preview-popup.css'

const InvoicePreviewPopup = (props) => {
    const {data: invoices, loading} = useFetch(`${baseUrl}/invoicesfamid/${props.invoicePopup}`)

    React.useEffect(() => {
        document.getElementById('invoice-preview-popup').style.transform = "scale(1)"
        document.getElementById('invoice-preview-popup').style.opacity = 1
        document.getElementById('invoice-preview-popup').style.maxHeight = '400px'
    }, [])

    return(
        <div className='invoice-preview-popup' id="invoice-preview-popup" onMouseLeave={() => props.setInvoicePopup(false)}>
            <div className='invoice-preview-popup__title'>Invoices</div>
            {loading && <div>loading...</div>}
            {[...invoices].reverse().map((inv) => (
                <div key={inv.invoiceId} className="invoice-preview-popup__open-invoice-btn" onClick={() => props.setInvoiceView(inv)}>{inv.monthYear}</div>
            ))}
            {invoices.length === 0 && <div>No Invoices Yet</div>}
        </div>
    )
}  
export default InvoicePreviewPopup